const handleReferenceSlider = () => {
  const overlayBtn = document.querySelector('.js-reference-overlay-btn');
  const overlay = document.querySelector('.js-reference-overlay');
  const images = document.querySelectorAll('.js-reference-img');
  const btnPrevious = document.querySelector('.js-reference-previous');
  const btnNext = document.querySelector('.js-reference-next');
  const imagesUrls = new Map();

  if(!(overlayBtn && overlay && images && btnPrevious && btnNext))
    return null;
    
  images.forEach(element => {
    const imgUrl = element.querySelector('source').srcset ?? '';
    const imgId = Number(element.dataset.id) ?? 0;
    console.log(imgId);
    if(imgUrl)
      imagesUrls.set(imgId,imgUrl);
    element.addEventListener('click', function (){
        changeImg(imgId);
        overlay.style.display = 'flex';
    });
  });

  const changeImg = (id) => {
    const imgUrl = imagesUrls.get(id);
    overlay.querySelector('img').src = imgUrl;
    if(id < imagesUrls.size - 1)
      btnNext.imgId = id + 1;
    else
      btnNext.imgId = 0;
    if(id > 0)
      btnPrevious.imgId = id - 1;
    else
      btnPrevious.imgId = imagesUrls.size - 1;
  }

  btnPrevious.addEventListener('click', function (){
    changeImg(btnPrevious.imgId);
  });
  btnNext.addEventListener('click', function (){
    changeImg(btnNext.imgId);
  });

  if(overlayBtn){
    overlayBtn.addEventListener('click', function () {
        overlay.style.display = 'none';
    });
  }

  overlay.addEventListener('click', event => {
    if(!overlay.querySelector('.js-reference-overlay-img').contains(event.target)){
      if(overlay.style.display != 'none'){}
        overlay.style.display = 'none';
    }
  });
};
export default handleReferenceSlider;